import CheckAvailability from "@/components/entities/accommodation/availability/CheckAvailability";

const AccommodationAvailabilityPrintPage = () => {
    const today = new Date();
    const next20Days = new Date(today.getTime() + (20 * 24 * 60 * 60 * 1000));

    return (
        <CheckAvailability 
            dates={{
                end: next20Days,
                start: today
            }} 
            name="accommodation-availability-print-page"
            readonly
       />
    );
};

export default AccommodationAvailabilityPrintPage;